/*
 * Enthält Hilfsfunktionen, die Abschnitte der JSON-Daten aus allOptions lesen und als Objekte zurückgeben
 */

import { trimName } from "./general";
import { Trans } from "@lingui/macro";

export function readModelsJson(allOptions) {
    // Gibt die Bettmodelle zurück
    let ret = {}
    allOptions.models.forEach(function (e) {
        if (allOptions.defaultConfigurations[e.articleId]) {
            let variants = []
            e.variants.forEach(function (v) {
                variants[v.width] = v.priceFrom
            })
            ret[e.articleId] = {
                key: e.articleId,
                name: e.name,
                description: e.shortDesc,
                info: e.infoText.value,
                widths: variants
            }
        }
    })
    return ret
}

export function readSizesJson(allOptions, configuration) {
    // Gibt die verfügbaren Bettgrößen für die angefragte Konfiguration zurück
    let ret = {},
        priceOfSelectedModelWidth = []
    allOptions.models.forEach(function (e) {
        if (allOptions.defaultConfigurations[e.articleId]) {
            let variants = []
            e.variants.forEach(function (v) {
                variants[v.width] = v.priceFrom
            })
            // Doppelbetten ab 160cm Breite sind aus zwei Einzelbetten zusammengesetzt:
            variants[160] = 2 * variants[80]
            variants[180] = 2 * variants[90]
            variants[200] = 2 * variants[100]
            if (e.articleId === configuration.modelId) {
                // Alle Varianten des aktuellen Modells speichern im Format {width: price}
                priceOfSelectedModelWidth = variants
            }
        }
    })
    allOptions.sizeConfiguration.dimensions.forEach(function(e) {
        let
            quantity = (e.size.type === 'double') ? 2 : 1,
            width = Math.trunc(e.size.width / quantity),
            price = priceOfSelectedModelWidth[e.size.width]
        if (priceOfSelectedModelWidth[e.size.width]) { // d.h. wenn das aktuell gewählte Bettmodell in dieser Breite exisitiert
            if (quantity > 1) {
                price = 2 * priceOfSelectedModelWidth[e.size.width / 2]
            }
            ret[quantity + '_' + e.size.width] = {
                id: quantity + '_' + width,
                oxid: e.size.id,
                parent: e.size.parentid,
                quantity: quantity,
                width: width,
                price: price,
            }
        }
    })
    return ret
}

export function readConnectorsJson(allOptions) {
    // Gibt die passenden Verbinder zurück, mit der Option "ohne Verbinder" am Ende
    let ret = {},
        noConnector
    allOptions.sizeConfiguration.fasteners.forEach(function(e) {
        if (e.noneOption) {
            noConnector = {
                key: e.articleId,
                name: e.name,
                price: e.price,
                img: e.image,
                none: true
            }
        } else {
            ret[e.articleId] = {
                key: e.articleId,
                name: e.name,
                price: e.price,
                img: e.image,
                none: e.isEmptyOption ? true : false
            }
        }
    })
    // Option "ohne" ans Ende sortieren:
    ret[noConnector.key] = noConnector
    return ret
}

export function readStacksSingleJson(allOptions) {
    // gibt die möglichen Stapeloptionen für Einzelbetten zurück (nur Bett / Bett + Matratze / Bett + Matratze + Topper)
    let ret = {}
    allOptions.mattressConfiguration.configurationTypes.forEach(function(e) {
        if (e.numBeds === 1) {
            ret[e.numMattresses + 'mattress_' + e.numToppers + 'topper'] = {
                key: e.numMattresses + 'mattress_' + e.numToppers + 'topper',
                name: e.name,
                img: 'img/' + 1 + 'bett-' + e.numMattresses + 'matratze-' + e.numToppers + 'topper.png',
                numMattresses: e.numMattresses,
                numToppers: e.numToppers,
                classList: ['mattress'+e.numMattresses, 'topper'+e.numToppers]
            }
        }
    })
    return ret
}

export function readStacksDoubleJson(allOptions) {
    // gibt die möglichen Stapeloptionen für Doppelbetten zurück (nur Bett / Bett + Matratze / Bett + Matratze + Topper)
    let ret = {}
    allOptions.mattressConfiguration.configurationTypes.forEach(function(e) {
        if (e.numBeds !== 1) {
            ret[e.numMattresses + 'mattress_' + e.numToppers + 'topper'] = {
                key: e.numMattresses + 'mattress_' + e.numToppers + 'topper',
                name: e.name,
                img: 'img/' + 2 + 'bett-' + e.numMattresses + 'matratze-' + e.numToppers + 'topper.png',
                classList: ['mattress'+e.numMattresses, 'topper'+e.numToppers]
            }
        }
    })
    return ret
}

export function readMattressesJson(allOptions) {
    // gibt die passenden Matratzen zurück
    let ret = {}
    allOptions.mattressConfiguration.mattresses.forEach(function(e) {
        e.variants.forEach(function (v) {
            ret[v.articleId] = {
                key: v.articleId,
                articleIdParent: e.articleId,
                nameRaw: v.name,
                width: v.width,
                height: v.height,
                hardness: v.firmness,
                hardnessText: v.firmness ? (v.firmness === 'H2' ? 'weich (H2)' : (v.firmness === 'H3' ? 'hart (H3)' : 'sehr hart (H3+)') ) : v.firmness,
                price: v.price.amount,
                img: v.image,
                washable: v.washable,
                flameRetardant: v.flameRetardant,
                badges: v.badges
            }
        })
    })
    return ret
}

export function readToppersJson(allOptions) {
    // gibt die passenden Topper zurück
    let ret = {}
    allOptions.mattressConfiguration.toppers.forEach(function(e) {
        e.variants.forEach(function (v) {
            ret[v.articleId] = {
                key: v.articleId,
                articleIdParent: e.articleId,
                nameRaw: v.name,
                width: v.width,
                height: v.height,
                hardness: v.firmness,
                hardnessText: v.firmness ? (v.firmness === 'H2' ? 'weich (H2)' : (v.firmness === 'H3' ? 'hart (H3)' : 'sehr hart (H3+)') ) : v.firmness,
                price: v.price.amount,
                img: v.image,
                washable: v.washable,
                abrasionResistant: v.abrasionResistant,
                flameRetardant: v.flameRetardant,
                foamType: v.foamType
            }
        })
    })
    return ret
}

export function readBackPartsJson(allOptions, artNum2Name) {
    // gibt die passenden Rückenteile zurück, mit der Option "ohne Rückenteil" am Ende
    let ret = {}
    allOptions.backParts.forEach(function(e) {
        ret[e.articleId] = {
            key: e.articleId,
            artNum: e.articleNum,
            name: e.name,
            description: e.shortDesc,
            info: 'H: ' + e.height + ', T: ' + e.thickness,
            price: e.price.amount,
            img: e.image,
        }
        artNum2Name[e.articleId] = trimName(e.name)
    })
    // Option "ohne" am Ende anhängen:
    ret['none'] = {
        key: '',
        name: <Trans>ohne Rückenteil</Trans>,
        description: '',
        more: '',
        price: 0,
        img: 'img/ohne-rueckenteil.png',
    }
    return ret
}

export function readFeetJson(allOptions, artNum2Name) {
    // gibt die passenden Fußsets zurück
    let ret = {}
    allOptions.footSets.forEach(function(e) {
        let feetVariants = []
        e.variants.forEach(function (v) {
            feetVariants[v.articleId] = {
                key: v.articleId,
                articleIdParent: e.articleId,
                name: v.variant,
                nameFull: v.name + ', ' + v.variant,
                feet: v.feet,
                wheels: v.wheels ? v.wheels : '0',
                height: v.height,
                price: v.price.amount
            }
        })
        artNum2Name[e.articleId] = trimName(e.name, e.articleNum)
        if (e.variants[0]) {
            ret[e.articleId] = {
                key: e.articleId,
                name: e.name,
                description: e.shortDesc,
                price: e.price.amount,
                img: e.image,
                variants: feetVariants
            }
        }
    })
    return ret
}

export function readColorNames(allOptions, colorFamilies) {
    // gibt die Farbnamen zurück, für die Stofffilter
    let ret = []
    Object.keys(allOptions.colorFamilies).map((family, i) => (
        allOptions.colorFamilies[family].forEach(function(e) {
            if (ret.indexOf(e) === -1) {
                ret.push(e)
            }
            if (!colorFamilies[family]) {
                colorFamilies[family] = []
            }
            colorFamilies[family].push(e)
        })
    ))
    return ret
}